export default __webpack_public_path__ + "704526c8b495b8227ec2f8e2a0b946bb.png";